import { gql } from "@apollo/client";

export default gql`
  mutation me {
    me {
      ok
      message
      data {
        _id
        branch
        branchs
        type
        username
        name
        email
        phone
        avatar
        address
        color
        lang
        tel
        fax
        mob

        billactive
        maxbranches

        roles
        publicKey

        isBranchAdmin
        isBranchsAdmin
        isAccountant
        isDepartAdmin
        isEmployee
        isFinance
        isOperate
        isPurchase
        isAdmin
        isEditor
        isWriter
        isViewer

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeePhone
        employeeColor

        stockId
        stockName
        stockNameAr

        verified
        payverified
        block
        themeId

        userId

        createdAt
        updatedAt
      }
      accessToken
      refreshToken
      hasCompany
      template
      tempId
      error
    }
  }
`;
